import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { IonInput, ModalController } from '@ionic/angular';
import Address from '../../../smoothr-web-app-core/models/Address';
import { MapsUtils } from '../../../smoothr-web-app-core/utils/maps-utils';

@Component({
	selector: 'app-address-input-dialog',
	templateUrl: './address-input-dialog.component.html',
	styleUrls: ['./address-input-dialog.component.scss'],
})
export class AddressInputDialog implements OnInit {
	@ViewChild('postalInput') postalInput: IonInput;

	address: Address;
	private numberRegex: RegExp = /^[0-9]+[a-zA-Z]?(\/[0-9]+[a-zA-Z]?)?$/;
	valid = false;
	numberDirty = false;
	fetchingPostal = false;
	postalAutoFilled = false;
	private numberDebounce: any;

	constructor(private modalCtrl: ModalController, private cdr: ChangeDetectorRef) {}

	ngOnInit() {
		this.validate();
	}

	static async show(modalCtrl: ModalController, address: Address): Promise<Address | null> {
		const modal = await modalCtrl.create({
			component: AddressInputDialog,
			cssClass: 'auto-height',
			componentProps: {
				address: {
					...address,
				},
			},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		const response = await modal.onDidDismiss();
		return response.data as Address | null;
	}

	onNumberChange(number: string) {
		this.address.number = number;
		this.numberDirty = true;
		this.postalAutoFilled = false;
		this.validate();
		clearTimeout(this.numberDebounce);
		if (this.numberRegex.test(number)) {
			this.numberDebounce = setTimeout(() => this.fetchPostalCode(number), 600);
		}
	}

	private async fetchPostalCode(number: string) {
		if (!this.address.street) {
			return;
		}
		this.fetchingPostal = true;
		this.cdr.detectChanges();
		try {
			const query = [this.address.street, number, this.address.city, this.address.country].filter(Boolean).join(', ');
			const result = await MapsUtils.getPlace(query);
			const geocoded = MapsUtils.placeToAddress(result);
			if (geocoded.postalCode && this.address.number === number) {
				this.address.postalCode = geocoded.postalCode;
				this.postalAutoFilled = true;
				const el = await this.postalInput.getInputElement();
				el.value = geocoded.postalCode;
			}
		} catch {}
		this.fetchingPostal = false;
		this.cdr.detectChanges();
	}

	onPostalChange(postalCode: string) {
		this.address.postalCode = postalCode;
		this.validate();
	}

	submit() {
		this.modalCtrl.dismiss(this.address);
	}

	cancel() {
		this.modalCtrl.dismiss(null);
	}

	validate() {
		this.valid = this.numberRegex.test(this.address.number);
	}
}
